import { call, select, put } from 'redux-saga/effects';
import { fetchAuthSession } from '@aws-amplify/auth';
import { jwtDecode } from 'jwt-decode';
import { setUserDetail } from './authSlice';
import { saveAuthToStorage } from '../utils/authStorageHelper';
import { isTokenExpired } from '../utils/tokenHelpers';
import { notifyUnauthorized } from '../api/unauthorizedHandler';

function* refreshUserTokens() {
    try {
        const { tokens } = yield call([fetchAuthSession, fetchAuthSession], { forceRefresh: true });
        
        return {
            accessToken: tokens?.accessToken?.toString(),
            idToken: tokens?.idToken?.toString(),
        };
    } catch (error) {
        console.error('Error refreshing tokens:', error);
        return null;
    }
}

export function* callWithAuth(api, data = {}, headers = {}, params = null) {
    let idToken = yield select((state) => state.auth?.user?.tokens?.idToken);

    if (!idToken) {
        notifyUnauthorized();
        throw new Error('Not signed in');
    }
    
    if (isTokenExpired(idToken)) {
        console.warn('ID token is expired or expiring soon, attempting to refresh...');
        const freshTokens = yield call(refreshUserTokens);
        
        if (freshTokens && freshTokens.idToken) {
            idToken = freshTokens.idToken;
            const currentUser = yield select((state) => state.auth?.user);
            const updatedUser = {
                ...currentUser,
                tokens: freshTokens,
            };
            yield put(setUserDetail(updatedUser));
            yield call(saveAuthToStorage, updatedUser);
        } else {
            notifyUnauthorized();
            throw new Error('Failed to refresh authentication token');
        }
    }
    
    const claims = jwtDecode(idToken.toString());
    const authHeaders = {
        ...headers,
        Authorization: `Bearer ${idToken}`,
    };
    
    let queryParams = null;
    if (params !== false) {
        queryParams = params ?? {};
        queryParams.companyId = claims['custom:companyId'];
    }

    if (Array.isArray(data)) {
        return yield call(api, ...data, authHeaders, queryParams);
    } else if (typeof data === 'object' && data !== null) {
        return yield call(api, data, authHeaders, queryParams);
    } else {
        throw new Error('Invalid data type: data must be an array or an object');
    }
}
